import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function Hero() {
  return <section className="relative w-full min-h-screen flex flex-col items-center justify-center px-6 py-20 md:py-32 overflow-hidden bg-navy" data-id="element-51">
      {/* Background Gradient */}
      <div className="absolute top-0 left-0 w-full h-full bg-warm-radial opacity-60 pointer-events-none" data-id="element-52" />

      <div className="relative z-10 max-w-4xl mx-auto text-center flex flex-col items-center" data-id="element-53">
        {/* Top Headline */}
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="font-serif text-4xl md:text-6xl lg:text-7xl font-bold text-cream leading-tight mb-8 text-balance" data-id="element-54">
          Si te despiertas a las 3AM, esto es lo que haces{' '}
          <span className="text-gold italic" data-id="element-55">(en 8 minutos).</span>
        </motion.h1>

        {/* Opening Lead */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2,
        ease: 'easeOut'
      }} className="max-w-2xl mx-auto mb-12 space-y-6 text-lg md:text-xl text-cream-muted leading-relaxed text-left md:text-center" data-id="element-56">
          <p data-id="element-57">
            Te despiertas. No sabes la hora, pero lo sientes: es ese despertar.
          </p>
          <p data-id="element-58">
            El cuerpo está incómodo. La mente se enciende. Y en menos de un
            minuto ya estás pensando:{' '}
            <span className="text-cream font-medium italic" data-id="element-59">
              «Si no me duermo ya, mañana voy a estar destruida.»
            </span>
          </p>
          <p data-id="element-60">
            Este PDF no viene a decirte «relájate». Viene a decirte qué hacer
            exactamente cuando pasa.
          </p>
        </motion.div>

        {/* Product Image */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 1,
        delay: 0.4,
        ease: 'easeOut'
      }} className="relative w-full max-w-2xl mb-12" data-id="element-61">
          <div className="absolute inset-0 bg-gold/20 blur-3xl rounded-full opacity-30 transform scale-90" data-id="element-62" />
          <img src="https://cdn.magicpatterns.com/uploads/ptbYhNUNvWTW7AkWM6BbYV/heylloyd-image-1770588321716.png" alt="El Protocolo 3AM en una tablet sobre mesa de noche" className="relative z-10 w-full h-auto rounded-lg shadow-2xl border border-navy-light/50" data-id="element-63" />
        </motion.div>

        {/* CTA Button */}
        <motion.a href="#comprar" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.6,
        ease: 'easeOut'
      }} whileHover={{
        scale: 1.02
      }} whileTap={{
        scale: 0.98
      }} className="group relative inline-flex items-center justify-center px-8 py-4 text-lg md:text-xl font-bold text-navy bg-gold hover:bg-gold-light transition-all duration-300 rounded-lg shadow-[0_0_20px_rgba(212,168,83,0.3)] hover:shadow-[0_0_30px_rgba(212,168,83,0.5)]" data-id="element-64">
          <span className="line-through text-navy/50 mr-2" data-id="element-65">$19</span>
          <span data-id="element-66">Descarga El Protocolo 3AM — $6.39</span>
          <span className="ml-2 px-2 py-0.5 text-sm font-bold bg-red-600 text-white rounded" data-id="element-67">
            -66%
          </span>
          <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-68" />
        </motion.a>
      </div>
    </section>;
}